import z from "zod";

/**
 * ObraAreaChecklistSchema
 */

export const ObraAreaChecklistSchema = z.object({
  status: z.coerce.number({ required_error: 'Este campo deve ser preenchido!' }).default(0),
  area: z.string({ required_error: 'Este campo deve ser preenchido!' }).nonempty('Este campo deve ser preenchido!'),
  checklists: z.array(z.number()).nullable().default(null),
});

/**
 * ObraAreaChecklistForm
 */

export type ObraAreaChecklistForm = z.infer<typeof ObraAreaChecklistSchema>;

/**
 * initialObraAreaChecklist
 */

export const initialObraAreaChecklist: Partial<ObraAreaChecklistForm> = {
  status: 0,
};